import { defineMessages, useIntl } from 'react-intl';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { DEFAULT_ORDERS_PAGE_URL } from '../../../services/user-permission-service';
import AdvancedHotkey from './component';

export const messages = defineMessages({
  name: {
    description: 'navigationHotkeys.OrdersPage',
    defaultMessage: 'Orders',
    id: 'XGJcgJ',
  },
});

export const hotkey = ['g', 'o'];
export const barcodeContent = '+5U5VHVFKXHZ3=';

const GotoOrdersPage = ({ children }) => {
  const intl = useIntl();
  const history = useHistory();
  const handler = useCallback(() => history.push(DEFAULT_ORDERS_PAGE_URL), [history]);
  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: ['go'],
      hotkey,
      handler,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'navigation',
      isGlobal: true,
    }),
    [intl, handler],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

GotoOrdersPage.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GotoOrdersPage;
